var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  stroke: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 38 38"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 2,
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 18,
  strokeOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M36 18c0-9.94-8.06-18-18-18"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  dur: "1s",
  from: "0 18 18",
  repeatCount: "indefinite",
  to: "360 18 18",
  type: "rotate"
})))));
export default SvgLoading;